import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from '../../local-storage.service';
import {MainDataService} from '../../services/main-data.service';
import {MainDataModels} from 'src/app/models/maindata-models';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {MatDialog} from '@angular/material/dialog';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {AufgabeEintragComponent} from '../pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';
import {MeineAufgabenDetailViewComponent} from '../meine-aufgaben-detail-view/meine-aufgaben-detail-view.component';


export interface AufgabenEintrag {
    taskUID: string;
}

@Component({
    selector: 'app-personal-task',
    templateUrl: './personal-task.component.html',
    styleUrls: ['./personal-task.component.scss']
})
export class PersonalTasksComponent implements OnInit {
    public taskList: AufgabenEintrag[] = [];
    public swissDatumFormat = {type: 'date', format: 'dd.MM.yyyy'};
    public taskLines!: MainDataModels.Aufgabe[];
    today = new Date();
    public innerWidth: any;
    private dbTasks?: MainDataModels.Aufgabe[];
    private storageWebMain: string = 'SwissWebMainDB';
    private currAufgabeMitBenutzern?: MainDataModels.AufgabeMitBenutzer;

    constructor(
        private svcMainData: MainDataService,
        private localStorageService: LocalStorageService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        private swissSettings: SwissSettingsService,
    ) {
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.loadTasks();
    }

    loadTasks() {
        // Pendenzen Live vom Webservice holen
        this.svcMainData.getOpenUserTasks().subscribe({
            next: (res) => {
                this.dbTasks = res;
                this.loadTaskList();
            },
            error: (err) => {
                // Webservice nicht verfügbar --> aus IndexedDB laden
                //TODO
                this.loadTermineFromIndexedDB();
            },
        });
    }

    loadTaskList() {
        if (this.dbTasks) {
            this.taskLines = [];

            this.dbTasks.sort((a, b) => {
                const dateA = a.dueDate || new Date();
                const dateB = b.dueDate || new Date();

                if (dateA < dateB) {
                    return -1;
                }
                if (dateA > dateB) {
                    return 1;
                }
                return 0;
            }).forEach((n, index) => {
                this.taskLines!.push({
                    objectID: n.objectID,
                    adressID: n.adressID,
                    contactID: n.contactID,
                    accepted: n.accepted,
                    description: n.description,
                    notes: n.notes,
                    importance: n.importance,
                    percentDone: n.percentDone,
                    taskUID: n.taskUID,
                    status: n.status,
                    responsible: n.responsible,
                    done: n.done,
                    private: n.private,
                    wasRead: n.wasRead,
                    reminder: n.reminder,
                    dueDate: n.dueDate,
                    startdate: n.startdate,
                });
            });
        }
    }

    checkDate(today: any, dueDate: any) {
        return today >= new Date(dueDate);
    }


    async loadTermineFromIndexedDB(): Promise<boolean> {
        return this.localStorageService
            .get('aufgaben', this.storageWebMain)
            .then((value) => {
                if (value === false) {
                    // Es konnte keinen Wert in der indexeddb für Objekte/Aufträge ermittelt werden
                    return false;
                } else {
                    // Die Aufträge konnten geladen werden
                    if (value) {
                        this.dbTasks = <MainDataModels.Aufgabe[]> value;
                        this.loadTaskList();
                    }
                    return true;
                }
            });
    }

    showDetails(auftrag: AufgabenEintrag) {
        this.svcMainData.loadTaskByID(auftrag.taskUID).subscribe({
            next: (res) => {
                this.dialog.open(MeineAufgabenDetailViewComponent, {
                    disableClose: true,
                    width: '800px',
                    data: res,
                });
            }
        });
    }

    showAufgabeDetail(auftrag: AufgabenEintrag) {
        this.svcMainData.loadTaskByID(auftrag.taskUID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(AufgabeEintragComponent, {
                    disableClose: true,
                    width: '800px',
                    data: res,
                });

                return dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        if (result) {
                            this.currAufgabeMitBenutzern = result;
                            // Update Informations
                            if (this.currAufgabeMitBenutzern) {
                                this.svcMainData
                                    .saveAufgabe(this.currAufgabeMitBenutzern)
                                    .subscribe({
                                        next: (res) => {
                                            this.svcMessageBox.showSuccess(
                                                'Die Aufgabe wurde erfolgreich gespeichert.',
                                                'Erfolgreich'
                                            );
                                            this.loadTaskList();
                                        },
                                        error: (error) => {
                                            console.log(error);
                                            this.svcMessageBox.showError(
                                                'Die Aufgabe konnte nicht gespeichert werden!!',
                                                '!! FEHLER !!'
                                            );
                                        },
                                    });
                            }
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log(
                                    'Dialog Resultat (currAufgabeMitBenutzern): ',
                                    this.currAufgabeMitBenutzern
                                );
                            }
                        }
                    },
                });
            },
        });
    }
}
